module.exports = __webpack_public_path__ + "img/img9.d6e0c9c0.jpg";